// Utility to process OCR text for Pokemon card name and number
// We'll use heuristic rules to extract these from typical OCR output strings

const extractCardNumber = (text) => {
  // Try to match patterns like '4/102⭑', '4/102', or just '4/102' ignoring trailing symbols
  const cardNumberMatch = text.match(/\b\d+\/\d+\b/);
  return cardNumberMatch ? cardNumberMatch[0] : '';
};

const extractCardName = (text) => {
  // Attempt to extract the card name from the text by heuristics:
  // 1. Usually appears right after keywords like 'STAGE X' or 'LV.' or before HP
  // 2. We'll try some regexes to find words that look like Pokemon names

  // Normalize string spacing
  const cleanedText = text.replace(/\s+/g, ' ');

  // Try after 'STAGE' keyword (ignore the stage number)
  const stageNameMatch = cleanedText.match(/STAGE \d+\s+([A-Z][a-zA-Z]+)/);
  if (stageNameMatch) {
    return stageNameMatch[1];
  }

  // Try after 'LV.' keyword
  const lvNameMatch = cleanedText.match(/LV\. \d+\s+([A-Z][a-zA-Z]+)/);
  if (lvNameMatch) {
    return lvNameMatch[1];
  }

  // Try before HP (e.g. 'Charizard 120 HP')
  const hpNameMatch = cleanedText.match(/([A-Z][a-zA-Z]+) \d+ HP/);
  if (hpNameMatch) {
    return hpNameMatch[1];
  }

  // As fallback, look for capitalized words that appear frequently (could be multiple Pokemon names, return first reasonable)
  // This fallback is broad and may return false positives
  const capitalWords = cleanedText.match(/\b[A-Z][a-z]{2,}\b/g);
  if (capitalWords && capitalWords.length > 0) {
    // Return the first capitalized word with length > 3 and exclude common keywords
    const blacklist = new Set(['Stage', 'Flame', 'Length', 'Weight', 'Energy', 'Fire', 'Spin', 'Discard']);
    for (const word of capitalWords) {
      if (!blacklist.has(word)) {
        return word;
      }
    }
  }

  return '';
};

export const processOCRText = (text) => {
  if (!text || text.length < 2) {
    return { cardName: '', cardNumber: '' };
  }

  const cardNumber = extractCardNumber(text);
  const cardName = extractCardName(text);

  return { cardName, cardNumber };
};

export default { processOCRText };
